export default __webpack_public_path__ + "static/media/ijazat.f1ccc81a.jpg";